<template>
  <div>
    <h1 v-if="false" class="text-center display-2 my-16 font-weight-bold">🎧 Podcasts</h1>
<ProjectComponent
    v-if="false"
      imgSrc="/img/projects/essay-self-aware-software-artisan-technology-andromeda-mario-novak.webp"
      class="my-16"
      :headerLink="{
        name: '🇬🇧 Software Artisan Podcast: Question everything',
        href: 'https://www.mixcloud.com/moltouni/question-everything-software-artisan-4/'
      }"
      :tags="[
        'Journaling',
        'Evaluating status and progress',
        'Adjusting your actions',
        'Choosing optimal solutions',
        'Improving yourself throughout time',
      ]"
      :descriptions="[
      ]"
      :points="[
        'To cut corners or to invest proper time to learn?',
        'Journaling',
        'Algorithms — chess for Technology enthusiasts',
        'Build as you learn',
        'Educational system',
        'Be able to play in an ever-changing World',
        'Scalable programming language',
        'Software Development',
      ]"
      :links="[
        {
          name: '📣 MixCloud',
          href: 'https://www.mixcloud.com/moltouni/question-everything-software-artisan-4/',
        },
      ]"
    ></ProjectComponent>
    <ProjectComponent
        v-if="false"
      class="my-16"
      :headerLink="{
  name: '🇭🇷 Testing for Beginners',
        href: 'https://soundcloud.com/moltouni/testiranje-za-pocetnike-hack-the-balkan-1-typescript-frontend-backend-programiranje'
      }"
      :tags="[
        'Problem Decomposition',
        'Data Mocking',
        'Test Driven Development',
        'TypeScript',
        'Frontend',
        'Backend',
      ]"
      :descriptions="[
      ]"
      :points="[
          'Why do we test our apps?',
          'Which parts should we test?',
          'Problem Decomposition.',
          'Data mocking.',
      ]"
      :links="[
        {
          name: 'SoundCloud',
          href: 'https://soundcloud.com/moltouni/testiranje-za-pocetnike-hack-the-balkan-1-typescript-frontend-backend-programiranje',
        },
      ]"
    ></ProjectComponent>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue'
import ProjectComponent from './ProjectComponent.vue';

export default defineComponent({
  name: "PodcastsComponent",
  components: {
    ProjectComponent,
  },
})
</script>
